import { PaginationMeta } from '@sr-sdks/api-sdk-axios';
import { Icon } from '@sr/ui-library';
import { Button } from 'react-daisyui';

type PaginationType = {
  firstRowNumber: number;
  lastRowNumber: number;
};

export enum Go {
  Next = +1,
  Prev = -1,
}

interface IAppTablePageCountProps {
  isLoading?: boolean;
  onPaginationClick: (go: Go) => void;
  paginationMeta?: PaginationMeta | null;
  paginationValues: PaginationType;
}

const AppTablePageCount = ({
  isLoading,
  onPaginationClick,
  paginationMeta,
  paginationValues,
}: IAppTablePageCountProps) => {
  return (
    <div className="flex items-center justify-center gap-2">
      {paginationMeta && paginationMeta.totalPages > 0 && (
        <span className="text-xs font-normal !leading-[3] opacity-50 sm:text-sm">
          {paginationValues.firstRowNumber}-{paginationValues.lastRowNumber} of{' '}
          {paginationMeta?.totalItems ?? 0}
        </span>
      )}
      {paginationMeta && paginationMeta.totalPages > 1 && (
        <>
          <Button
            className="h-9 w-9 hover:bg-sr-opacity-primary hover:text-sr-input-outline disabled:!bg-transparent"
            color="ghost"
            disabled={
              isLoading ||
              paginationMeta?.totalItems === 0 ||
              paginationMeta?.currentPage === 1
            }
            shape="circle"
            size="sm"
            startIcon={<Icon icon="chevronLeft" size="xl" />}
            onClick={() => onPaginationClick(Go.Prev)}
          >
            <span className="sr-only">Previous</span>
          </Button>
          <Button
            className="h-9  w-9 hover:bg-sr-opacity-primary hover:text-sr-input-outline disabled:!bg-transparent"
            color="ghost"
            disabled={
              isLoading ||
              paginationMeta?.totalItems === 0 ||
              paginationMeta?.currentPage === paginationMeta?.totalPages
            }
            endIcon={<Icon icon="chevronRight" size="xl" />}
            shape="circle"
            size="sm"
            onClick={() => onPaginationClick(Go.Next)}
          >
            <span className="sr-only">Next</span>
          </Button>
        </>
      )}
    </div>
  );
};

export default AppTablePageCount;
